import { useTranslation, Trans } from 'react-i18next'
import { Flex, Box, Link } from '@chakra-ui/react'

import { Body } from 'atoms/typography'

import USCSFLogo from './icons/USCSFLogo'

const IWitnessTermsLink = 'https://iwitness.usc.edu/assets/html/termsofuse.html'
const IWitnessPrivacyLink =
  'https://iwitness.usc.edu/assets/html/privacypolicy.html'

const Footer: React.FC = () => {
  const { t } = useTranslation()

  const sectionWidth = { base: '100%', md: '33%' }
  const sectionMargin = { base: '4', md: '0' }

  return (
    <Flex
      w="full"
      minH="4"
      mt="34"
      bg="paleWhite"
      as="footer"
      py={{ base: '8', md: '4' }}
      px="8"
      alignItems="center"
      justifyContent={{ base: 'space-between' }}
      flexDirection={{ base: 'column', md: 'row' }}
    >
      <Box
        w={sectionWidth}
        mb={sectionMargin}
        textAlign={{ base: 'center', md: 'left' }}
      >
        <Body size="sm" color="offBlack">
          <Trans
            t={t}
            i18nKey={'site.termsAndPrivacy'}
            components={{
              TermsLink: <Link target="_blank" href={IWitnessTermsLink} />,
              PrivacyLink: <Link target="_blank" href={IWitnessPrivacyLink} />,
            }}
          />
        </Body>
      </Box>
      <USCSFLogo ariaLabel={t('site.logoAltText')} width="24" />
      <Box
        w={sectionWidth}
        mt={sectionMargin}
        textAlign={{ base: 'center', md: 'right' }}
      >
        <Body size="sm" color="offBlack">
          {t('site.copyrightText', {
            year: new Date().getFullYear(),
          })}
        </Body>
      </Box>
    </Flex>
  )
}
export default Footer
